import { useEffect, useState } from 'react';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const queries: Record<Breakpoint, string> = {
  xs: '(max-width: 639px)',
  sm: '(min-width: 640px) and (max-width: 767px)',
  md: '(min-width: 768px) and (max-width: 1023px)',
  lg: '(min-width: 1024px) and (max-width: 1279px)',
  xl: '(min-width: 1280px) and (max-width: 1535px)',
  '2xl': '(min-width: 1536px)',
};

export function useBreakpoint() {
  const getCurrent = (): Breakpoint => {
    if (typeof window === 'undefined') {
      return 'lg';
    }

    if (window.matchMedia(queries.xs).matches) {
      return 'xs';
    }
    if (window.matchMedia(queries.sm).matches) {
      return 'sm';
    }
    if (window.matchMedia(queries.md).matches) {
      return 'md';
    }
    if (window.matchMedia(queries.lg).matches) {
      return 'lg';
    }
    if (window.matchMedia(queries.xl).matches) {
      return 'xl';
    }

    return '2xl';
  };

  const [breakpoint, setBreakpoint] = useState<Breakpoint>(getCurrent);

  useEffect(() => {
    const mediaQueryLists = Object.entries(queries).map(([key, query]) => ({
      key: key as Breakpoint,
      mql: window.matchMedia(query),
    }));

    const update = () => {
      const active = mediaQueryLists.find(({ mql }) => mql.matches);
      if (active) {
        setBreakpoint(active.key);
      }
    };

    // listener para todos os breakpoints
    mediaQueryLists.forEach(({ mql }) => {
      mql.addEventListener('change', update);
    });

    update();

    return () => {
      mediaQueryLists.forEach(({ mql }) => {
        mql.removeEventListener('change', update);
      });
    };
  }, []);

  return {
    breakpoint,
    isXs: breakpoint === 'xs',
    isSm: breakpoint === 'sm',
    isMd: breakpoint === 'md',
    isLg: breakpoint === 'lg',
    isXl: breakpoint === 'xl',
    is2xl: breakpoint === '2xl',
  };
}
